import type { BackofficeAdmin } from '@repo/sdk/gen'
import { z } from 'zod'
import i18n from '@/lib/i18n'

// Known limitation: validation messages are resolved at module-load and
// therefore frozen to the initial language.

// The ability vocabulary lives in the SDK. We keep a runtime tuple (zod enum
// and combobox options need the values) but anchor it to the BE type via
// `satisfies`, so a backend change to `abilities` breaks compilation here
// instead of drifting silently. String literals (not the `AdminAbility` enum)
// keep values assignable to the SDK's union-typed `abilities` without casts.
export type AdminAbilityValue = BackofficeAdmin['abilities'][number]

export const ADMIN_ABILITIES = [
	'admins.manage'
] as const satisfies readonly AdminAbilityValue[]

const abilitiesField = z
	.array(z.enum(ADMIN_ABILITIES))
	.min(1, i18n.t('admin-admins:invite.validation.abilities_invalid'))

export const InviteAdminFormSchema = z.object({
	name: z
		.string()
		.trim()
		.min(1, i18n.t('admin-admins:invite.validation.name_invalid')),
	email: z.email(i18n.t('admin-admins:invite.validation.email_invalid')),
	abilities: abilitiesField
})
export type InviteAdminFormSchema = z.infer<typeof InviteAdminFormSchema>

export const EditAbilitiesFormSchema = z.object({
	abilities: abilitiesField
})
export type EditAbilitiesFormSchema = z.infer<typeof EditAbilitiesFormSchema>
